export default __webpack_public_path__ + "static/media/people_type_female_active.0e0c3fb4.svg";